import React from 'react';
import NombreUnites from './NombreUnites';
import NombreFractions from './NombreFractions';
import VisibilityNumbers from './VisibilityNumbers';

export default () => (
    <footer className="mastfoot mt-auto">
        <h4 className="inner">
            <NombreUnites />
            <NombreFractions />
            <VisibilityNumbers/>
        </h4>
    </footer>
);
